<template>
	<Row id="custom-row">
		<div class="xl:container gap-[80px]">
			<layout>
				<article
					id="legal-pages"
					class="entry-content"
				>
					<header class="entry-header">
						<header class="entry-header">
							<h1 class="entry-title">
								{{ pageTitle }}
							</h1>
						</header>
					</header>
					<div>
						<p>
							Tim Sykes teaches people how to day trade penny stocks to help them
							discover personal financial responsibility and live life on their own
							terms.
						</p>

						<p>Our editorial team is driven by those same goals.</p>

						<h2>
							<strong>Our Mission</strong>
						</h2>

						<p>
							Deliver clear and concise trading education to create self-sufficient and
							successful traders.
						</p>

						<h2>
							<strong>Our Vision</strong>
						</h2>
						<p>
							A financial education industry and trading community that’s built on
							trust and transparency.
						</p>

						<h2>
							<strong>Editorial Team — About Us</strong>
						</h2>

						<p>
							The Tim Sykes editorial team delivers content, trade ideas, lessons, and
							market insights from Tim Sykes, and many of the successful traders that
							have gone through mentorship and become millionaires.
						</p>

						<p>
							We strive to take the complex world of financial markets and day trading
							and break it down into easy-to-understand lessons and content for our
							readers to easily digest.
						</p>

						<p>
							Our team delivers well-researched, timely, and accurate information to
							our readers through all our blog posts, newsletters, emails, and
							subscriptions.
						</p>

						<h2>
							<strong>Key Principles</strong>
						</h2>
						<ul class="list">
							<li>
								We believe freedom through managing your own personal finances and
								understanding the market is possible for everyone. You don't need a
								finance degree or diploma.
							</li>
							<li>
								Our team believes in full transparency and we identify our outside
								sources of information and cite them in our copy where appropriate.
							</li>
							<li>
								We deliver information on a wide variety of market terms and trading
								strategies so every trader has the opportunity to find their own unique
								trading style.
							</li>
							<li>
								Our team is accepting and inclusive and we welcome everyone to engage
								with our content and join our communities.
							</li>
						</ul>

						<h2>
							<strong>How We Make Money</strong>
						</h2>
						<p>
							Timothy Sykes strives to bring transparency into the trading and
							financial industry. And our editorial team is committed to the same
							goals.
						</p>

						<p>
							We make money through the sale of educational trading courses and
							products. And if we share an affiliate link to an outside source, we let
							you know with a disclaimer right in our copy.
						</p>

						<p>
							If you see a factual error in any of our content, please report it to our
							team at
							<a href="mailto:editorial@timothysykes.com">
								editorial@timothysykes.com
							</a>
							and we’ll correct it as soon as possible.
						</p>
					</div>
				</article>
			</layout>
		</div>
	</Row>

	<Head>
		<Title>{{ pageTitle }} - Timothy Sykes</Title>
		<Link
			rel="canonical"
			:href="`${current_hostname}${pageSlug}/`"
		/>
	</Head>
</template>
<script setup>
// WP page slug is 'editorialguidelines' (no hyphen) — different from the
// Nuxt route name 'editorial-guidelines'.  The composable fetches under the
// WP slug but builds the canonical URL from $route.name as usual.
const { pageTitle } = await useLegalPage("editorialguidelines");
</script>
<style lang="scss">
@import "@assets/utils.scss";

#custom-row {
	display: block;

	@include breakpoint(lg) {
		display: flex;
	}
}

#custom-row #toc_container .toc_title {
	margin-bottom: 0;
}

#custom-row .content p {
	margin-bottom: 32px;
}

#custom-row .content .toc_list a {
	color: #fff;
}

#custom-row #toc_container ul li {
	font-weight: 600;
}

#custom-row ol li {
	padding-left: 8px;
	@include breakpoint(lg) {
		padding-left: 16px;
	}
}
#custom-row ul li,
#custom-row ol li {
	padding-left: 8px;
	@include breakpoint(lg) {
		padding-left: 16px;
	}
}

#custom-row ul li,
#custom-row ol li::marker {
	content: "■";
	color: #3b82f6;
}

#custom-row ol li ol li::marker {
	content: "■";
	color: #1e3a8a;
}

#custom-row td {
	padding: 8px 8px;
	border: 1px solid #000;
}

#custom-row p strong {
	@include breakpoint(lg) {
		padding-left: 16px;
	}
}

#custom-row .entry-content ul li,
#custom-row .content ul li {
	color: #1e293b;
	font-family: Rubik;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%;
	margin-bottom: 32px;
	padding-left: 8px;
}
#custom-row .entry-content a,
#custom-row .content a {
	color: #3b82f6;
}

#custom-row .content ul li,
#custom-row .entry-content ul li {
	color: #1e293b;
	font-family: Rubik;
	font-size: 18px;
	font-style: normal;
	font-weight: 400;
	line-height: 160%;
	margin-bottom: 32px;
	padding-left: 8px;
}

#custom-row .entry-content ul.list li {
	list-style: none !important;
	position: relative !important;
	padding: 0 0 0 33px !important;
	color: #000 !important;
}

#custom-row .entry-content ul.list li:before {
	content: "" !important;
	display: block !important;
	width: 8px !important;
	height: 8px !important;
	background: #3fa9f5 !important;
	position: absolute !important;
	top: 0.8333333333em !important;
	left: 0 !important;
	margin-top: -4px !important;
}
</style>
